import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Should be true in prod and dev. But occasionally helpful to disable in dev for testing purposes
const isStrictMode = true;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("dp-messenger-container")!).render(
  isStrictMode ? (
    <StrictMode>
      <App />
    </StrictMode>
  ) : (
    <App />
  ),
);
